
import Vue from 'vue'

export default Vue.extend({
    props: {
        text: String
    },
    data: () => {
        return { showSpinner: false }
    },
    mounted() {
        setTimeout(() => {
            this.showSpinner = true
        }, 500)
    }
})
